export var PersistentDownloadFileAccessMode;
(function (PersistentDownloadFileAccessMode) {
    PersistentDownloadFileAccessMode["AUTHENTICATED_CREATOR"] = "authenticated_creator";
    PersistentDownloadFileAccessMode["AUTHENTICATED_PROJECT"] = "authenticated_project";
    PersistentDownloadFileAccessMode["SIGNED"] = "signed";
    PersistentDownloadFileAccessMode["LEGACY_PUBLIC"] = "legacy_public";
})(PersistentDownloadFileAccessMode || (PersistentDownloadFileAccessMode = {}));
/** Which bucket holds the object; the download path reads from the same one. */
export var PersistentDownloadFileStorage;
(function (PersistentDownloadFileStorage) {
    PersistentDownloadFileStorage["EXPORTS"] = "exports";
    PersistentDownloadFileStorage["UPLOADS"] = "uploads";
})(PersistentDownloadFileStorage || (PersistentDownloadFileStorage = {}));
//# sourceMappingURL=persistentDownloadFile.js.map